// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__R2v1O","clinicsSelect":"TableHeading_clinicsSelect__RKyYG"};